import React, { useState } from 'react';
import { useQuery } from '../../hooks';

import styles from './RecoveryPage.module.css';

const RecoveryPage = () => {
  let query = useQuery();
  const lang = query.get('lang') || 'en-US';

  const translations = {
    'en-US': {
      enterNewPassword: 'Enter your new password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      change: 'Change',
      success: 'Sucess! 😉',
      tryLogging: 'Try logging back into your account.',
      errorOccurred: 'An error occurred. Please try again later.',
    },
    'pt-BR': {
      enterNewPassword: 'Digite sua nova senha',
      newPassword: 'Nova senha',
      confirmNewPassword: 'Confirme a nova senha',
      showPassword: 'Exibir senha',
      hidePassword: 'Ocultar senha',
      change: 'Alterar',
      success: 'Sucesso! 😉',
      tryLogging: 'Tente fazer login novamente em sua conta.',
      errorOccurred: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
    },
    'es-ES': {
      enterNewPassword: 'Ingresa tu nueva contraseña',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirma la nueva contraseña',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Oculta la contraseña',
      change: 'Cambiar',
      success: '¡Éxito! 😉',
      tryLogging: 'Intenta ingresar nuevamente a tu cuenta.',
      errorOccurred:
        'Ocurrió un error. Por favor, inténtalo de nuevo más tarde.',
    },
  };

  const t = translations[lang];

  const [values, setValues] = useState({
    password: '',
    password2: '',
  });

  const [errors, setErrors] = useState({ message: '' });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [visible, setVisble] = useState(false);

  return (
    <div className={styles.app}>
      <div>
        <form className={styles.form} onSubmit={handleSubmit} noValidate>
          <div className={styles.appHeader}>
            <img src="/images/logo.svg" className={styles.appLogo} alt="logo" />
          </div>

          {!isSubmitted ? (
            <>
              <h1> {t.enterNewPassword} </h1>

              <div className={styles.formInputs}>
                <label htmlFor="password" className={styles.formLabel}>
                  {t.newPassword}
                </label>
                <input
                  id="password"
                  type={visible ? 'text' : 'password'}
                  name="password"
                  className={styles.formInput}
                  placeholder={t.newPassword}
                  value={values.password}
                  onChange={handleChanges}
                />
              </div>

              <div className={styles.formInputs}>
                <label htmlFor="password2" className={styles.formLabel}>
                  {t.confirmNewPassword}
                </label>
                <input
                  id="password2"
                  type={visible ? 'text' : 'password'}
                  name="password2"
                  className={styles.formInput}
                  placeholder={t.confirmNewPassword}
                  value={values.password2}
                  onChange={handleChanges}
                />
              </div>

              <div
                className={styles.iconTouch}
                onClick={() => setVisble(!visible)}
              >
                <p>{visible ? t.hidePassword : t.showPassword}</p>
                <img
                  src={visible ? 'icons/visibility.png' : 'icons/invisible.png'}
                  alt="eye"
                  className={styles.iconStyle}
                />
              </div>

              <button className={styles.formInputBtn} type="submit">
                {t.change}
              </button>

              {errors.message && (
                <div className={styles.erroBox}>
                  <p>{errors.message}</p>
                </div>
              )}
            </>
          ) : (
            <div className={styles.successBox}>
              <p>{t.success} </p>
              <p>{t.tryLogging}</p>
            </div>
          )}
        </form>
      </div>
    </div>
  );

  function handleChanges(e) {
    const { name, value } = e.target;
    setErrors({ message: '' });
    setValues({
      ...values,
      [name]: value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setErrors({ message: '' });

    try {
      if (values.password.length < 6) {
        setErrors({ message: 'Password must be at least 6 characters' });
        return;
      }

      if (
        !values.password ||
        !values.password2 ||
        values.password !== values.password2
      ) {
        setErrors({
          message:
            'Password and confirm password shoud be equals and not empty!!',
        });
        return;
      }

      const token = query.get('token');
      const BASE_URL = `${process.env.REACT_APP_BASE_API}/auth-reset-password`;

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ password: values.password, token: token }),
      };

      const request = await fetch(BASE_URL, options);

      if (request.status === 200) {
        setIsSubmitted(true);
      } else {
        const result = await request.json();
        setErrors({ message: result.message ?? t.errorOccurred });
      }
    } catch (err) {
      console.error('Password reset error:', err);
      setErrors({ message: t.errorOccurred });
    }
  }
};

export default RecoveryPage;
